// constants
import {
  getClinicalRoomTypes,
  getNonClinicalRoomTypes,
} from '../../constants/roomTypes';
// components
import RoomTypesExplainerItem from '../roomTypeExplainerItem';

interface Props {
  heading: string;
  intro: string;
  showItemButton?: boolean;
  roomCategory: 'clinical' | 'non-clinical' | 'both';
  wrapImageWithLink?: boolean;
  wrapHeadingWithLink?: boolean;
  displayExplainerItemText?: boolean;
}

const RoomTypesExplainer = ({
  heading,
  intro,
  showItemButton,
  roomCategory,
  wrapImageWithLink,
  wrapHeadingWithLink,
  displayExplainerItemText,
}: Props) => {
  const renderRoomTypes = (
    rooms: ReturnType<typeof getClinicalRoomTypes>,
    category: string
  ) => {
    return (
      <div
        className={`room-types-explainer__content room-types-explainer--${category}`}
      >
        {rooms.map((room, index) => (
          <RoomTypesExplainerItem
            {...room}
            key={index}
            showButton={showItemButton}
            wrapImageWithLink={wrapImageWithLink}
            wrapHeadingWithLink={wrapHeadingWithLink}
            displayText={displayExplainerItemText}
          />
        ))}
      </div>
    );
  };

  const renderRooms = (category: string) => {
    switch (category) {
      case 'clinical':
        return renderRoomTypes(getClinicalRoomTypes(), category);
      case 'non-clinical':
        return renderRoomTypes(getNonClinicalRoomTypes(), category);
      default: {
        return [
          renderRoomTypes(getClinicalRoomTypes(), 'clinical'),
          renderRoomTypes(getNonClinicalRoomTypes(), 'non-clinical'),
        ];
      }
    }
  };

  return (
    <section className="room-types-explainer" id="alternative-room-types">
      <h1 className="room-types-explainer__heading">{heading}</h1>
      <h4 className="room-types-explainer__intro">{intro}</h4>
      {renderRooms(roomCategory)}
    </section>
  );
};

export default RoomTypesExplainer;
